(() => {
  'use strict';

  const addDays = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, 12, 0, 0);

  const isArabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  const formatDeliveryDate = (date) => new Intl.DateTimeFormat(isArabic() ? 'ar-EG' : (document.documentElement.lang || 'en'), {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
  }).format(date);

  const renderDeliveryWindows = () => {
    const today = new Date();
    const earliest = addDays(today, 2);
    const latest = addDays(today, 5);
    const earliestLabel = formatDeliveryDate(earliest);
    const latestLabel = formatDeliveryDate(latest);
    const earliestIso = earliest.toISOString().slice(0, 10);
    const latestIso = latest.toISOString().slice(0, 10);

    document.querySelectorAll('[data-nawah-delivery-estimate]').forEach((root) => {
      const copy = root.querySelector('p');
      if (!copy) return;

      copy.innerHTML = isArabic()
        ? `اطلب اليوم ليصلك طلبك بين <time datetime="${earliestIso}">${earliestLabel}</time> و<time datetime="${latestIso}">${latestLabel}</time>.`
        : `Order today to receive it between <time datetime="${earliestIso}">${earliestLabel}</time> and <time datetime="${latestIso}">${latestLabel}</time>.`;
    });
  };

  const initOfferTab = () => {
    const root = document.querySelector('[data-nawah-offer-tab]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const trigger = root.querySelector('[data-nawah-offer-trigger]');
    const panel = root.querySelector('[data-nawah-offer-panel]');
    const close = root.querySelector('[data-nawah-offer-close]');

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      trigger?.setAttribute('aria-expanded', String(open));
      panel?.setAttribute('aria-hidden', String(!open));
      if (open) close?.focus({ preventScroll: true });
    };

    trigger?.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) setOpen(false);
    });
    document.addEventListener('pointerdown', (event) => {
      if (root.classList.contains('is-open') && !root.contains(event.target)) setOpen(false);
    });
  };

  const init = () => {
    renderDeliveryWindows();
    initOfferTab();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Keep the date promise correct if a product page remains open across midnight.
  window.setInterval(renderDeliveryWindows, 60 * 60 * 1000);
})();
